import * as Sentry from '@sentry/react';
import { history } from 'userportal/history';
import { persistState, clearPersistedState } from 'shared/lib/persistedState';
import apiClient from 'userportal/lib/ApiClient';
import {
  AUTH_LOGIN_SUCCEEDED,
  AUTH_SIGNUP_SUCCEEDED,
  AUTH_LOGOUT,
  AUTH_FORCE_LOGOUT,
  AUTH_USER_UPDATED,
  AUTH_SET_LANGUAGE,
  AUTH_SET_CURRENCY,
  AUTH_STATE_RESTORED
} from 'userportal/ducks/auth';
import { PROFILE_UPDATED, PROFILE_PARSE_SUCCESS } from 'userportal/ducks/profile';
import { SET_VISITED } from 'userportal/ducks/visited';
import { actions as globalActions } from 'userportal/ducks/global';
import googleAnalytics from 'userportal/lib/googleAnalytics';
import sklik from 'userportal/lib/sklik';
import { preloadUserChunk } from 'userportal/lib/preloadUserChunk';
import { userportal as routes } from 'shared/routes';
import i18n from 'shared/i18n/init';

i18n.on('initialized', () => {
  i18n.changeLanguage(i18n.language);
});

export default function ({ dispatch, getState }) {
  return next => (action) => {
    if (action.type === AUTH_LOGOUT || action.type === AUTH_FORCE_LOGOUT) {
      apiClient.setToken(null);
      apiClient.setData({});
      clearPersistedState();
      Sentry.setUser(null);
      googleAnalytics.setUserId(undefined);
      googleAnalytics.setCurrency(undefined);
      dispatch(globalActions.resetState());
      if (action.type === AUTH_LOGOUT) {
        history.replace('/');
      }
    }

    if (action.type === AUTH_LOGIN_SUCCEEDED || action.type === AUTH_SIGNUP_SUCCEEDED) {
      if (action.result.success === true) {
        apiClient.setToken(action.result.token);
        if (action.result.user.language) {
          apiClient.setLanguage(action.result.user.language);
          apiClient.setCurrency(action.result.user.currency);
          i18n.changeLanguage(action.result.user.language);
        }
        preloadUserChunk();
      }
      dispatch(globalActions.bulkLoad());
    }

    const nextResult = next(action);

    // after reducer

    const nextState = getState();
    if (action.type === AUTH_USER_UPDATED || action.type === PROFILE_UPDATED || action.type === AUTH_SET_LANGUAGE || action.type === AUTH_SET_CURRENCY || action.type === PROFILE_PARSE_SUCCESS) {
      persistState({ auth: nextState.auth, visited: nextState.visited });
      googleAnalytics.setCurrency(nextState.auth.user.currency);
      googleAnalytics.setLanguage(nextState.auth.language);
      apiClient.setLanguage(nextState.auth.language);
      apiClient.setCurrency(nextState.auth.user.currency);
    }

    if (action.type === AUTH_LOGIN_SUCCEEDED || action.type === AUTH_SIGNUP_SUCCEEDED) {
      // apiClient.setToken(nextState.auth.token);
      Sentry.setUser({
        id: nextState.auth.user.id,
        username: nextState.auth.user.email,
        email: nextState.auth.user.email,
      });
      googleAnalytics.setUserId(nextState.auth.user.id);
      googleAnalytics.setLanguage(nextState.auth.language);
      googleAnalytics.setCurrency(nextState.auth.user.currency);
      persistState({ auth: nextState.auth, visited: nextState.visited });
      // dispatch(globalActions.bulkLoad());

      if (action.type === AUTH_SIGNUP_SUCCEEDED && action.result.success === true) {
        googleAnalytics.event('signup_finished');
        try {
          window.lintrk('track', { conversion_id: 6459137 });
        } catch {}
        history.replace(routes.user.profile.view);
      }

      if (action.type === AUTH_LOGIN_SUCCEEDED && action.result.success === true) {
        if (action.result.oauth) {
          if (action.result.oauthSignup) {
            googleAnalytics.event('user_signup');
            sklik.reportConversion();
          } else {
            googleAnalytics.event('user_login');
          }

          history.replace(routes.oauth.signup);
        } else {
          googleAnalytics.event('user_login');
        }
        try {
          window.lintrk('track', { conversion_id: 6459137 });
        } catch {}
      }
    }

    if (action.type === AUTH_STATE_RESTORED) {
      Sentry.setUser({
        id: nextState.auth.user.id,
        username: nextState.auth.user.email,
        email: nextState.auth.user.email,
      });
      googleAnalytics.setUserId(nextState.auth.user.id);
      googleAnalytics.setLanguage(nextState.auth.language);
      googleAnalytics.setCurrency(nextState.auth.user.currency);
    }

    if (action.type === SET_VISITED) {
      persistState({ auth: nextState.auth, visited: nextState.visited });
    }

    return nextResult;
  };
}
